import React, { useState, useMemo } from 'react';
// import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, GetTagProps, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress, Chip } from '@material-ui/core';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import gql from 'graphql-tag';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { useQuery } from 'react-apollo';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         removedAvatar: {
//             maxWidth: '15px',
//             maxHeight: '15px',
//         },
//     }),
// );

interface MatterCountrySelectorProps {
    disabled?: boolean;
    required?: boolean;
    // tslint:disable-next-line: no-any
    value?: CountryAutoCompleteItem | CountryAutoCompleteItem[] | any; // value only available in single select
    error?: boolean;
    onSelection?: (value?: CountryAutoCompleteItem | CountryAutoCompleteItem[], name?: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    style?: React.CSSProperties;
    disablePortal?: boolean;
    variant?: 'standard' | 'filled' | 'outlined';
    size?: 'small' | 'medium';
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
    multiple?: boolean;
    isApplyMatterAccess?: boolean;
}

export interface CountryAutoCompleteItem extends IAutoCompleteItem, Country {}

interface MatterCountrySelectorState {
    data: CountryAutoCompleteItem[];
}

export const MatterCountrySelector: React.FC<MatterCountrySelectorProps> = (props) => {
    // const classes = useStyles();

    const [state, setState] = useState<MatterCountrySelectorState>({
        data: [],
    });

    const matterCountryQuery = useQuery<MatterCountryData, MatterCountryParams>(CountryQuery, {
        variables: {
            isApplyMatterAccess: props.isApplyMatterAccess
        },
        fetchPolicy: 'cache-first'
    });

    useMemo(() => {
        if (!matterCountryQuery.loading && !matterCountryQuery.error && matterCountryQuery.data && matterCountryQuery.data.lookup && matterCountryQuery.data.lookup.country) {
            setState((prevState) => {
                const { country } = matterCountryQuery.data!.lookup;

                const items: CountryAutoCompleteItem[] = country.map((cntry: Country) => {
                    return {
                        ...cntry,
                        label: cntry.country,
                        value: cntry.country,
                    };
                });
                return {
                    ...prevState,
                    data: items,
                };
            });
        }
    // tslint:disable-next-line: align
    }, [matterCountryQuery.loading, matterCountryQuery.data, matterCountryQuery.error]);

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        if (props.onSelection) {
            props.onSelection(value, props.name);
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return {
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                    {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                </React.Fragment>
            ),
        };
    };

    const onRenderTags = (value: CountryAutoCompleteItem[], getTagProps: GetTagProps): React.ReactNode => {
        let renderTagsValue = value.map((option: CountryAutoCompleteItem, index: number) => {
            let label = option.label;
            if (option.label.length > 20) {
                label = `${option.label.substring(0, 20)}...`;
            }

            return (
                <Chip
                    {...getTagProps({ index })}
                    key={index}
                    label={label}
                    // variant="outlined"
                    size="small"
                />
            );
        });

        return renderTagsValue;
    };

    if (props.multiple) {
        return (
            <Autocomplete
                style={props.style}
                className={props.className}
                value={props.value}
                loading={matterCountryQuery.loading}
                disabled={props.disabled}
                onChange={handleChange}
                options={state.data}
                disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                // tslint:disable-next-line: jsx-no-lambda
                getOptionLabel={(option: CountryAutoCompleteItem) => option.label}
                // tslint:disable-next-line: jsx-no-lambda
                onBlur={props.onBlur}
                multiple={true}
                renderTags={onRenderTags}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={props.label}
                        variant={props.variant}
                        fullWidth={true}
                        margin="none"
                        required={props.required}
                        InputProps={getInputProps(params, matterCountryQuery.loading)}
                        error={props.error}
                        size={props.size}
                    />
                )}
                // tslint:disable-next-line: jsx-no-lambda
                renderOption={(option, { inputValue }) => {
                    const matches = match(option.label, inputValue);
                    const parts = parse(option.label, matches);

                    return (
                        <div>
                            {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                </span>
                            ))}
                        </div>
                    );
                }}
            />
        );
    }
    return (
        <Autocomplete
            style={props.style}
            className={props.className}
            value={props.value}
            loading={matterCountryQuery.loading}
            disabled={props.disabled}
            onChange={handleChange}
            options={state.data}
            disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
            // tslint:disable-next-line: jsx-no-lambda
            getOptionLabel={(option: CountryAutoCompleteItem) => option.label}
            // tslint:disable-next-line: jsx-no-lambda
            onBlur={props.onBlur}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant={props.variant}
                    fullWidth={true}
                    margin="none"
                    required={props.required}
                    InputProps={getInputProps(params, matterCountryQuery.loading)}
                    error={props.error}
                    size={props.size}
                />
            )}
            // tslint:disable-next-line: jsx-no-lambda
            renderOption={(option, { inputValue }) => {
                const matches = match(option.label, inputValue);
                const parts = parse(option.label, matches);

                return (
                    <div>
                        {parts.map((part, index) => (
                            <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                            </span>
                        ))}
                    </div>
                );
            }}
        />
    );
};

export interface MatterCountryParams {
    isApplyMatterAccess?: boolean;
}

export interface MatterCountryData {
    lookup: Lookup;
}

export interface Lookup {
    country: Country[];
}

export interface Country {
    id: number;
    countryId: number;
    country: string;
    countryCode: null;
}

const CountryQuery = gql`
    query country($isApplyMatterAccess: Boolean) {
        lookup {
            country(isApplyMatterAccess: $isApplyMatterAccess) {
                id
                countryId
                country
                countryCode
            }
        }
    }
`;
